export const tokenKey = 'tansack.auth.token';
